export interface SupportOnlineAgent {
  userId: string;
  name: string;
  avatarUrl?: string | null;
}

export interface SupportHeaderAgent extends SupportOnlineAgent {
  featured?: boolean;
}

export function getSupportInitials(name?: string) {
  const parts = (name || "Wembii")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "W";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] || ""}${parts[1]![0] || ""}`.toUpperCase();
}

function shuffleAgents<T>(items: T[]) {
  const copy = [...items];
  for (let index = copy.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [copy[index], copy[swapIndex]] = [copy[swapIndex]!, copy[index]!];
  }
  return copy;
}

export function pickSupportHeaderAgents(
  agents: SupportOnlineAgent[],
  lastReplierId?: string | number | null,
  max = 4
): SupportHeaderAgent[] {
  if (!agents.length) return [];

  const featuredId = lastReplierId ? String(lastReplierId) : null;
  const featured = featuredId
    ? agents.find((agent) => String(agent.userId) === featuredId)
    : undefined;
  const others = agents.filter(
    (agent) => String(agent.userId) !== featuredId
  );
  const pickedOthers = shuffleAgents(others).slice(0, featured ? max - 1 : max);

  const result: SupportHeaderAgent[] = pickedOthers.map((agent) => ({
    ...agent,
    featured: false,
  }));

  if (featured) {
    result.push({ ...featured, featured: true });
  }

  return result.slice(0, max);
}

export function uniqueAgentsFromMessages(
  messages: Array<{
    senderType: "user" | "agent";
    senderId: number;
    senderName?: string;
    senderAvatar?: string | null;
  }>
): SupportOnlineAgent[] {
  const byId = new Map<string, SupportOnlineAgent>();

  messages
    .filter((message) => message.senderType === "agent")
    .forEach((message) => {
      const userId = String(message.senderId);
      if (!byId.has(userId)) {
        byId.set(userId, {
          userId,
          name: message.senderName || "Equipo Wembii",
          avatarUrl: message.senderAvatar ?? null,
        });
      }
    });

  return Array.from(byId.values());
}
